<template>
  <div class="checkout-success">
    <div class="wrapper">
      <div class="content">
        <p><span class="success-icon"><i></i></span></p>
        <p class="words">下单成功</p>
        <p class="return-home"><span @click="goToHome()">返回首页</span></p>
      </div>
    </div>


    <div class="footer">
      <p>
        如有问题任何请联系客服
      </p>
      <p>客服电话: 17621085394</p>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../utils.scss";
    $base-color:#79BD50;
  .checkout-success {
    background: white;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    height: 100vh;
    .wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .success-icon {
        display: inline-block;
        height: px2rem(70px);
        width:  px2rem(70px);
        border-radius: px2rem(70px);
        border: px2rem(4px) solid $base-color;
        i {
          display: inline-block;
          height: px2rem(25px);
          width:  px2rem(40px);
          border: px2rem(4px) solid $base-color;
          border-top: transparent;
          border-right: transparent;
          transform: rotate(-45deg);
          margin-top: px2rem(15px);
        }
      }
      .content {
        text-align: center;
      }
      .words {
        margin-top: px2rem(17px);
        @include font-dpr(22px);
        font-weight: bold;
        color: #333333;
      }
      .return-home {
        margin-top: px2rem(31px);
        border: 1px solid #E5E5E5;
        color: #333;
        @include font-dpr(16px);
        border-radius: px2rem(4px);
        height: px2rem(32px);
        width: px2rem(112px);
        line-height: px2rem(32px);
      }
    }
    .footer {
      @include font-dpr(13px);
      color: #999999;
      margin-bottom: px2rem(30px);
    }
  }
</style>

<script>
export default {
  name: 'hello',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    };
  },
  created() {
     window.localStorage.setItem('zrb-first-order', 'true');
  },
  methods: {
      goToHome() {
        this.$router.replace('/shop');
      }
  }
};
</script>



// WEBPACK FOOTER //
// CheckoutSuccess.vue?ac32f264